export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
            'Header': 'Uniconta legitimationsoplysninger',
            'Comapny': 'Firma',
            'CustomerVATOptions': 'Debitor Momskode',
        },
        'FIELDS': {
            'UserName': 'Bruger navn',
            'Password': 'Adgangskode',
            'AccessId': 'Access id',
            'ComapnyName': 'Firma navn',
            'ComapnyId': 'Firma id',
            'GenerateSalesOrders': 'Generer salgsordrer',
            'GenerateInvoices': 'Generer fakturaer',
            'GenerateTXTFile': 'Generer TXT File',
            'Path': 'Sti/filnavn',        
            'AmountToGenerateInvoice': 'Aconto faktura skal være på kr.(Excl. moms)',
            'SelectForInvoiceLine': 'Vælg Til fakturalinje',
            'ESCHoursToSend': 'Til kl.', 
            'SelectCoworker': 'Vælg medarbejdar',
            'MoreAmountToGenerateInvoice':'Send aconto faktura når sag er over kr.(Excl. moms)',
            'ESCHoursFromSend': 'Send aconto faktura kl.'
         },
        'VALIDATIONS': {
        },
        'MESSAGES': {
            'Saved': 'Gemt Succesfuldt.',
        },
        'BUTTONS': {
            'Save': 'Gem',
            'AddCompany':'Tilføj firma'
        },
        'Help':{
            'Note':'Brug kun skråstreg(/) i stiindstilling',
        }
    }
};

